import { noop } from "lodash";

const disableConsole = () => {
    console.warn = noop;
    console.log = noop;
    console.dir = noop;
    console.trace = noop;
}

export default disableConsole;